<form #axonform="ngForm">
	<div *ngIf="formData && formData.data && formData.data.cards" [hidden]="!state && state !== 'ready'">
		<div class="card" *ngFor="let card of formData.data.cards">
			<div class="card-header">{{card.card}}</div>
			<div class="card-body">
				<ng-container *ngFor="let field of card.fields; let i = index">
					<ng-container *ngIf="field.formControl && field.hidden === 0">
							<div [ngSwitch]="true">
								<!-- drop downs -->
								<div *ngSwitchCase="field.inputField === 'dropdown' || field.inputField === 'dropdown_filter'">
									<div class="row">
										<div class="col mb-3">
											<div class="form-floating">
												<select class="form-select" 
													[id]="field.id"
													[formControl]="field.formControl"
													(selectionChange)="handleFieldChange(field)" [required]="field.mandatory === 1">
													<option *ngFor="let lov of field.lovValues" [value]="lov">{{lov}}</option>
												</select>
												<label [for]="field.id">{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span></label>
												<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
													{{field.field}} is required
												</div>
											</div>
										</div>
									</div>
								</div>
								<!-- Dates -->
								<div *ngSwitchCase="field.inputField === 'date' || field.inputField === 'date_manual'">
									<div class="row">
										<div class="col mb-3">
											
											<div class="form-floating">
												<input 
													class="form-control"
													name="dp" 
													ngbDatepicker #d="ngbDatepicker"
													(click)="d.toggle()"
													[id]="field.id" 
													[name]="field.field" 
													[formControl]="field.formControl"
													[minDate]="field.minDate" 
													[maxDate]="field.maxDate"
													[readonly]="field.editable == 0"
													[required]="field.mandatory === 1">
												<label [for]="field.id">{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span></label>
												<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
													{{field.field}} is required
												</div>
											</div>
												
												<!-- <np-datepicker [id]="field.id" [(ngModel)]="field.formControl.value" language="en" class="form-control"></np-datepicker>
												<label [for]="field.id">{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span></label>
												<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
													{{field.field}} is required
												</div> -->
												<!-- <input 
													class="form-control"
													name="dp" 
													ngbDatepicker #d="ngbDatepicker"
													[startDate]="field.charType === 'pastdate' ? {year: 1980, month: 1} : {year: 2000, month: 2}"
													(click)="d.toggle()"
													[id]="field.id" 
													[name]="field.field" 
													[formControl]="field.formControl"
													[min]="field.minDate" 
													[max]="field.maxDate"
													[readonly]="field.editable == 0"
													(change)="handleFieldChange(field)">
												<label [for]="field.id">{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span></label>
												<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
													{{field.field}} is required
												</div> -->
											<!-- <div class="form-group">
												<label *ngIf="!field.formControl.pristine" [for]="field.id">
													<span class="h6 small bg-white text-muted pt-1 pl-2 pr-2">
														{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span>
													</span>
												</label>
												<input class="form-control" [ngClass]="{'mt-n3': !field.formControl.pristine}"
													placeholder="yyyy-mm-dd"
													name="dp" 
													ngbDatepicker #d="ngbDatepicker"
													[startDate]="field.charType === 'pastdate' ? {year: 1980, month: 1} : {year: 2000, month: 2}"
													(click)="d.toggle()"
													[id]="field.id" 
													[name]="field.field" 
													[formControl]="field.formControl"
													[placeholder]="field.field" 
													[min]="field.minDate" 
													[max]="field.maxDate"
													[readonly]="field.editable == 0"
													(change)="handleFieldChange(field)">
												
												<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
													{{field.field}} is required
												</div>
											</div> -->
										</div>
									</div>
								</div>
								<div *ngSwitchCase="field.inputField === 'tickbox'">
									<div class="row">
										<div class="col mb-3">
											<div class="form-group">
												<label [for]="field.id">
													<span class="h6 small bg-white text-muted pt-1 pl-2 pr-2">
														{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span>
													</span>
												</label>
												<input type="checkbox" class="form-control form-check-input" [formControl]="field.formControl" (change)="handleFieldChange(field)">
												
												<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
													{{field.field}} is required
												</div>
											</div>
										</div>
									</div>
								</div>
								<div *ngSwitchCase="field.inputField === 'camera'">
									<div class="row">
										<div class="">
											<div class="form-group">
												<app-dynamic-image [file]="field.formControl.value" [title]="field.field" [useWebcam]="field.fieldMapping.columnName === 'customer_portrait'" (change)="setFile(field, $event)"></app-dynamic-image>
											</div>
										</div>
									</div>
								</div>
								<div *ngSwitchCase="field.inputField === 'display_contract'">
									<div class="row">
										<div class="">
											<div class="form-group">
												<app-sign-pad [file]="field.formControl.value" (onSignatureComplete)="setSignature(field, $event)"></app-sign-pad>
											</div>
										</div>
									</div>
								</div>
								<div *ngSwitchCase="field.inputField === 'display'">
									<div class="row">
										<div class="">
											<div class="form-group">
												{{field.field}}
											</div>
										</div>
									</div>
								</div>
								<div *ngSwitchCase="field.inputField === 'chooser'">
									<app-linked-list-dropdown #linkedListCascade
										*ngIf="field.linkedListValue"
										[fieldId]="field.id"
										[placeholder]="field.placeholder"
										[parentList]="field.linkedListValue"
										[formCtrl]="field.formControl"
										[mandatory]="field.mandatory"
										(change)="setChooserValue($event, field)"></app-linked-list-dropdown>
									<app-linked-list-dropdown #linkedListFlat
										*ngIf="field.lovValues"
										[fieldId]="field.id"
										[placeholder]="field.field"
										[listValues]="field.lovValues"
										[formCtrl]="field.formControl"></app-linked-list-dropdown>		
										<div *ngIf="field.formControl.touched && !field.formControl.value" class="alert alert-danger">
											{{field.field}} is required
										</div>
									<!-- <div *ngIf="dmsLocations.length > 0">
										<app-map [locationData]="dmsLocations" (onLocationChosen)="setLocation($event)"></app-map>	
									</div>						 -->
								</div>
								<div *ngSwitchDefault>
									<ng-container *ngIf="isFieldNumeric( field ); else standardInput">
										
										<div class="row">
											<div class="col mb-3">
												<div class="form-floating">
													<input type="number" 
														class="form-control"
														[id]="field.id" 
														[name]="field.field" 
														[formControl]="field.formControl"
														[maxlength]="field.max" 
														[minlength]="field.min" 
														[readonly]="field.editable == 0"
														[value]="field.value"
														(change)="handleFieldChange(field)">
													<label [for]="field.id">{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span></label>
													<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
														<div *ngIf="field.formControl.errors.required">{{field.field}} is required</div>
														<div *ngIf="field.formControl.errors.minlength">{{field.field}} must be at least {{field.min}} characters long</div>
														<div *ngIf="field.formControl.errors.maxlength">{{field.field}} must not be more than {{field.max}} characters long</div>
														<div *ngIf="field.formControl.errors.pattern">{{field.patternError}}</div>
													</div>
												</div>
											</div>
										</div>
									</ng-container>
									<ng-template #standardInput>
											<ng-container *ngIf="field.max >= 200; else textInput">
												<div class="row">
													<div class="col mb-3">
														<div class="form-floating">
															<textarea 
																class="form-control"
																[id]="field.id" 
																[name]="field.field" 
																[formControl]="field.formControl"
																[maxlength]="field.max" 
																[minlength]="field.min" 
																[readonly]="field.editable == 0"
																[value]="field.value"
																(change)="handleFieldChange(field)"
																[required]="field.mandatory === 1"></textarea>
															<label [for]="field.id">{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span></label>
															<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
																<div *ngIf="field.formControl.errors.required">{{field.field}} is required</div>
																<div *ngIf="field.formControl.errors.email">{{field.field}} must be an email address</div>
																<div *ngIf="field.formControl.errors.minlength">{{field.field}} must be at least {{field.min}} characters long</div>
																<div *ngIf="field.formControl.errors.maxlength">{{field.field}} must not be more than {{field.max}} characters long</div>
																<div *ngIf="field.formControl.errors.invalidDate">{{ field.formControl.errors['invalidDate'] }}</div>
																<div *ngIf="field.formControl.errors.specialsAndNums">{{ field.field }} must not contain numeric and / or special characters</div>
																<div *ngIf="field.formControl.errors.pattern">{{field.patternError}}</div>
															</div>
														</div>
														<!-- <div class="form-group">
															<label *ngIf="field.formControl.value?.trim() !== ''" [for]="field.id">
																<span class="h6 small bg-white text-muted pt-1 pl-2 pr-2">
																	{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span>
																</span>
															</label>
															<textarea class="form-control" [ngClass]="{'mt-n3': field.formControl.value?.trim() !== ''}"
																[id]="field.id" 
																[name]="field.field" 
																[formControl]="field.formControl"
																[placeholder]="field.field" 
																[maxlength]="field.max" 
																[minlength]="field.min" 
																[readonly]="field.editable == 0"
																[value]="field.value"
																(change)="handleFieldChange(field)">
															</textarea>
															<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
																<div *ngIf="field.formControl.errors.required">{{field.field}} is required</div>
																<div *ngIf="field.formControl.errors.email">{{field.field}} must be an email address</div>
																<div *ngIf="field.formControl.errors.minlength">{{field.field}} must be at least {{field.min}} characters long</div>
																<div *ngIf="field.formControl.errors.maxlength">{{field.field}} must not be more than {{field.max}} characters long</div>
																<div *ngIf="field.formControl.errors.invalidDate">{{ field.formControl.errors['invalidDate'] }}</div>
																<div *ngIf="field.formControl.errors.specialsAndNums">{{ field.field }} must not contain numeric and / or special characters</div>
																<div *ngIf="field.formControl.errors.pattern">{{field.patternError}}</div>
															</div>
														</div> -->
													</div>
												</div>
											</ng-container>
											<ng-template #textInput>
												<div class="row" *ngIf="field.hidden === 0">
													<div class="col mb-3">
														<div class="form-floating">
															<input type="text" 
																class="form-control"
																[id]="field.id" 
																[name]="field.field" 
																[formControl]="field.formControl"
																[maxlength]="field.max" 
																[minlength]="field.min" 
																[readonly]="field.editable == 0"
																[value]="field.value"
																(change)="handleFieldChange(field)"
																[required]="field.mandatory === 1">
															<label [for]="field.id">{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span></label>
															<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
																<div *ngIf="field.formControl.errors.required">{{field.field}} is required</div>
																<div *ngIf="field.formControl.errors.email">{{field.field}} must be an email address</div>
																<div *ngIf="field.formControl.errors.minlength">{{field.field}} must be at least {{field.min}} characters long</div>
																<div *ngIf="field.formControl.errors.maxlength">{{field.field}} must not be more than {{field.max}} characters long</div>
																<div *ngIf="field.formControl.errors.invalidDate">{{ field.formControl.errors['invalidDate'] }}</div>
																<div *ngIf="field.formControl.errors.specialsAndNums">{{ field.field }} must not contain numeric and / or special characters</div>
																<div *ngIf="field.formControl.errors.pattern">{{field.patternError}}</div>
															</div>
														</div>
														<!-- <div class="form-group">
															<label *ngIf="field.formControl.value?.trim() !== ''" [for]="field.id">
																<span class="h6 small bg-white text-muted pt-1 pl-2 pr-2">
																	{{field.field}}<span class="mandatory">{{field.mandatory === 1 ? '*' : ''}}</span>
																</span>
															</label>
															<input type="text" class="form-control" [ngClass]="{'mt-n3': field.formControl.value?.trim() !== ''}" 
																[id]="field.id" 
																[name]="field.field" 
																[formControl]="field.formControl"
																[placeholder]="field.field" 
																[maxlength]="field.max" 
																[minlength]="field.min" 
																[readonly]="field.editable == 0"
																[value]="field.value"
																(change)="handleFieldChange(field)">
															<div *ngIf="field.formControl.touched && field.formControl.invalid" class="alert alert-danger">
																<div *ngIf="field.formControl.errors.required">{{field.field}} is required</div>
																<div *ngIf="field.formControl.errors.email">{{field.field}} must be an email address</div>
																<div *ngIf="field.formControl.errors.minlength">{{field.field}} must be at least {{field.min}} characters long</div>
																<div *ngIf="field.formControl.errors.maxlength">{{field.field}} must not be more than {{field.max}} characters long</div>
																<div *ngIf="field.formControl.errors.invalidDate">{{ field.formControl.errors['invalidDate'] }}</div>
																<div *ngIf="field.formControl.errors.specialsAndNums">{{ field.field }} must not contain numeric and / or special characters</div>
																<div *ngIf="field.formControl.errors.pattern">{{field.patternError}}</div>
															</div>
														</div> -->
													</div>
												</div>
											</ng-template>
									</ng-template>
								</div>
							</div>
					</ng-container>
				</ng-container>
				<button *ngIf="formData.data.cards.length === 1 && showSaveButton" type="button" 
					[disabled]="form && !form.valid" class="btn btn-axon-save btn-md btn-block text-uppercase waves-effect waves-light mt-4" (click)="save()">Save</button>

				<div *ngIf="formData.data.cards.length > 1">
					<div class="mt-3"></div>
				</div>
			</div>
		</div>
		<button *ngIf="formData.data.cards.length > 1 && showSaveButton" type="button" 
			[disabled]="form && !form.valid" class="btn btn-axon-save btn-md btn-block text-uppercase waves-effect waves-light mt-4" (click)="save()">Save</button>
	</div>
</form>
